import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import usePage from "./usePage";

export default function () {
  const {pageFields, handleSubmit, setData, setErrors} = usePage();

  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`pages/create`).then(res => {
      if(res.data.status === 'success'){
        setData(res.data);
      }
    });
  }, []);

  const add = data => {
    axios.post(`pages`, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Page has been created successfully!', {
            icon: "success",
          });
          navigate("/pages");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Add Page">
      <form className="form w-100 row" onSubmit={handleSubmit(add)}>
        {pageFields}

        <SubmitButton
          title="Create"
          classes="w-auto d-inline-block mt-4"
        />
      </form>
    </Card>
  );
}